import { Alert, Card, Form, Input, InputNumber, Typography } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { FileDoneOutlined } from '@ant-design/icons';
import { IAssessmentAttempt } from 'interfaces/assessments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { TagField, useForm } from '@refinedev/antd';
import { tagColorByStatus } from '../../../utils/statusColorMapping';
import { translateAssessmentAttemptStatus } from '../../../services/assessments';

export const AssessmentAttemptEdit = () => {
  const { formProps, saveButtonProps, queryResult } =
    useForm<IAssessmentAttempt>({
      redirect: 'list'
    });

  const attempt = queryResult?.data?.data;

  const disabled = ['failed', 'passed'].includes(attempt?.status ?? '');

  return (
    <EditLayout saveButtonProps={{ ...saveButtonProps, disabled }}>
      <PageHeader title="Corrigir tarefa" icon={FileDoneOutlined} />

      <Card>
        {disabled ? (
          <Alert
            style={{ marginBottom: 20 }}
            description={
              <>
                Essa tarefa já foi avaliada como{' '}
                <TagField
                  color={tagColorByStatus(attempt?.status ?? '')}
                  value={translateAssessmentAttemptStatus(
                    attempt?.status ?? ''
                  )}
                />
                e não pode ser modificada
              </>
            }
            type="warning"
          />
        ) : (
          <Alert
            style={{ marginBottom: 20 }}
            description={
              <>
                Você está avaliando a tarefa: <b>{attempt?.assessment.name}</b>
                <br />
                do curso/disciplina de: <b>{attempt?.assessment.course_name}</b>
              </>
            }
            type="info"
          />
        )}
        <Typography.Title level={5}>
          1. Avalie o trabalho do aluno
        </Typography.Title>
        <Form disabled={disabled} {...formProps} layout="vertical">
          <Form.Item
            label="Nota (0 - 100)"
            name="score"
            rules={[
              {
                required: true
              }
            ]}
          >
            <InputNumber min={0} max={100} />
          </Form.Item>
          <Form.Item
            label="Feedback"
            name="feedback"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea style={{ width: 500, height: 150 }} />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
